import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { calculateApplicationArea } from 'util/applicationArea';
import { FieldThumbnail } from '@tcc/crate';
import { getMessage } from 'util/locale';
import ColorBullet from 'common/ColorBullet';

const baseString = 'vra-trial-placements-card';

const bulletColorPurple = {
  r: 149,
  g: 39,
  b: 175
};

const TrialPlacementsQuickView = ({
  headerText,
  selectedTrialPlacementsId,
  onSelectTrialPlacements,
  placementsData
}) => {
  const isSelected = placementsData.id === selectedTrialPlacementsId;
  const classString = classNames({
    [`${baseString}`]: true,
    'isSelected': isSelected
  });
  const onSelect = () => onSelectTrialPlacements(placementsData.id);

  let trialPlacementOptionApplicationArea = calculateApplicationArea(
    placementsData.geoJson.features.find(
      (feature) => feature.properties.name === 'field'
    ).properties.area,
    placementsData.geoJson.features.find(
      (feature) => feature.properties.name === 'champion'
    ).properties.area
  );

  return (
    <div
      className={classString}
      data-test-id={baseString}
      key={placementsData.id}
      onClick={onSelect}
    >
      <FieldThumbnail
        fillColor="white"
        geoJson={placementsData.geoJson}
        hasRegion={true}
        height={100}
        regionColor="#D3D3D3"
        regionFillOpacity={0.7}
        width={100}
      />
      <div className={`${baseString}-header-text`}>
        {headerText}
        <div className="trial-option-application-area">
          <ColorBullet className="bullet-application-area" color={bulletColorPurple} />
          {getMessage('text__application-rate--application-area')}
          <span className="application-area">
            {trialPlacementOptionApplicationArea.q.toFixed(1)}{' '}
            {trialPlacementOptionApplicationArea.u}
          </span>
        </div>
      </div>
    </div>
  );
};

TrialPlacementsQuickView.propTypes = {
  headerText: propTypes.string.isRequired,
  onSelectTrialPlacements: propTypes.func.isRequired,
  placementsData: propTypes.object.isRequired,
  selectedTrialPlacementsId: propTypes.string.isRequired
};

export default TrialPlacementsQuickView;
